import { LocalRepository } from '@lib/api/repository/local';
import {
  LocalCartInput,
  LocalItemInput,
  LocalOfferFilters,
  LocalSessionInput,
  LocalSessionUpdateInput,
} from '@lib/types/local';

export default class LocalService {
  constructor(private readonly repository: LocalRepository) {}
  sessions(signal?: AbortSignal) {
    return this.repository.sessions(signal);
  }

  sessionBySlug(slug: string, signal?: AbortSignal) {
    return this.repository.sessionBySlug(slug, signal);
  }

  session(id: string, signal?: AbortSignal) {
    return this.repository.session(id, signal);
  }

  offers(
    id: string,
    search: string,
    page: number,
    signal?: AbortSignal,
    filters?: LocalOfferFilters,
  ) {
    return this.repository.offers(id, search, page, signal, filters);
  }

  ownerOrders(signal?: AbortSignal) {
    return this.repository.ownerOrders(signal);
  }

  orders(id: string, signal?: AbortSignal) {
    return this.repository.orders(id, signal);
  }

  cart(input: LocalCartInput, signal?: AbortSignal) {
    return this.repository.cart(input, signal);
  }

  filters(id: string, signal?: AbortSignal) {
    return this.repository.filters(id, signal);
  }

  updateSession(input: LocalSessionUpdateInput) {
    return this.repository.updateSession(input);
  }

  createSession(input?: LocalSessionInput) {
    return this.repository.createSession(input);
  }

  closeSession(id: string) {
    return this.repository.closeSession(id);
  }

  createCart(sessionId: string) {
    return this.repository.createCart(sessionId);
  }

  updateCart(input: LocalItemInput) {
    return this.repository.updateCart(input);
  }

  submit(input: LocalCartInput) {
    return this.repository.submit(input);
  }

  approve(id: string) {
    return this.repository.approve(id);
  }

  reject(id: string) {
    return this.repository.reject(id);
  }
}
